import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import IconPng from 'atoms/IconPng'
import { Accordion } from './styles'
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment';

const ic_arrow_up = require('App/assets/images/ic_arrow_up.png')
const ic_arrow_down = require('App/assets/images/ic_arrow_down.png')

export class LogHistory extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isLogHistoryExpanded: false,
    }
  }

  showLogHistory() {
    const { isLogHistoryExpanded } = this.state
    this.setState({ isLogHistoryExpanded: !isLogHistoryExpanded })
  }

  render() {
    const { theme, blastingReportData } = this.props
    const columns = [{
      dataField: 'created_at',
      text: 'Date',
      formatter: (cell) => {
        return moment(cell).format('YYYY-MM-DD');
      },
      headerStyle: {
        backgroundColor: '#EBEAFF',
        width: '150px'
      }
    }, {
      dataField: 'user.display_name',
      text: 'User',
      headerStyle: {
        backgroundColor: '#EBEAFF',
        width: '150px'
      }
    }, {
      dataField: 'log',
      text: 'Log',
      headerStyle: {
        backgroundColor: '#EBEAFF',
        width: 'auto'
      }
    }]

    return (
      <>
        <Accordion
          color={theme.mocaPurple}
          height={'37px'}
          padding={'0px 12px'}
          bg={'#EBEAFF'}
          mb={'8px'}
          onClick={() => this.showLogHistory()}
        >
          Log History
          {
            this.state.isLogHistoryExpanded ? (
              <IconPng srcIcon={ic_arrow_up} mx={"8px"} size={"auto"} h={"10"} />
            ) : (
              <IconPng srcIcon={ic_arrow_down} mx={"8px"} size={"auto"} h={"10"} />
            )
          }
        </Accordion>
        {this.state.isLogHistoryExpanded && 
          <BootstrapTable
            keyField='id'
            noDataIndication="Table is Empty"
            columns={columns}
            data={blastingReportData.approvalLogs.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))}
          />
        }
      </>
    )
  }
}

export default withTheme(LogHistory)
